import React from "react";
import "react-dropzone-uploader/dist/styles.css";
import Dropzone from "react-dropzone-uploader";
import { apiFileUpload } from "util/services";
import { notification } from "antd";
import firebase from "FirebaseConfig.js";
import { useSelector, useDispatch } from 'react-redux';
import { UPDATE_USER } from 'redux/user/actions';
import { useTranslation } from 'react-i18next';

const Uploader = ({ user }) => {
  const theme = useSelector(state => state.DashboardReducer.theme);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleChangeStatus = ({ meta, remove }, status) => {
    console.log(status, meta);
  };
  const handleFiles = async (files) => {
    const f = files[0];
    const json = await apiFileUpload("users/upload-logo", f["file"]);

    if (json && json.logo_url) {
      const logo_url = json.logo_url;
      notification.success({ message: t("notifications.99") });

      firebase
        .database()
        .ref(`/users/${user.uid}/`)
        .set({ ...user, logo_url })
        .catch(() => notification.error({ message: t("settings.98") }));

      dispatch({ type: UPDATE_USER, payload: { logoUrl: logo_url } });
    } else {
      notification.error({ message: t("notifications.100") });
    }
  };

  return (
    <Dropzone
      onChangeStatus={handleChangeStatus}
      onSubmit={handleFiles}
      maxFiles={1}
      multiple={false}
      canCancel={false}
      inputContent={theme === 'dark' ? <img width={70} height={70} src={"/assets/cloud_download.svg"} alt="" /> : <img width={70} height={70} src={"/assets/cloud_download_black.svg"} alt="" />}
      //   styles={{
      //     dropzone: { width: 400, height: 200 },
      //     dropzoneActive: { borderColor: "green" },
      //   }}

      styles={{
        dropzone: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "28px 16px",
          width: "100%",
          overflow: "hidden",
          border: "none",
          borderRadius: "0",
          margin: "0",
          background: "transparent",
          minHeight: "100px",
        },
        dropzoneActive: {
          color: "var(--font)",
          fontFamily: "Poppins",
          fontSize: "12px",
          fontWeight: "100",
        },
        submitButton: {
          backgroundColor: theme === "brand" ? "#4A4D4E" : "#4400aa",
          color: "#fff",
          fontSize: "12px",
          fontFamily: "Poppins",
          borderRadius: "8px",
        },
      }}
    />
  );
};

export default Uploader;